import { templateStoreCategoriesByTemplateId } from './templateStoreCategories.data';

/**
 * Store collection category names per template meta site ID.
 * Used in the siteless flow when categories are not copied from a full template install.
 */
export type TemplateStoreCategoriesMap = Record<string, readonly string[]>;

export function getTemplateStoreCategoryNames(templateMetaSiteId: string): readonly string[] | undefined {
  return templateStoreCategoriesByTemplateId[templateMetaSiteId];
}

export function hasTemplateStoreCategoryMapping(templateMetaSiteId: string): boolean {
  const names = getTemplateStoreCategoryNames(templateMetaSiteId);
  return Boolean(names?.length);
}
